/**
 * Tageslimits eines LinkedIn-Kontos — eine Quelle für beide Limit-Masken (Einrichtung
 * Schritt „Limits" und der Dialog „Limits & Account-Arbeitszeit bearbeiten").
 *
 * Vorher empfahl jede Maske etwas anderes: der Assistent ≤ 20 InMails, der Dialog 25 —
 * dieselben 25 standen im Assistenten rot. Der Dialog rechnete Kontaktanfragen und
 * Nachrichten aus Wochenwerten (150 / 1250) durch die Zahl der Arbeitstage, bei leerem
 * Arbeitsfenster also 150 Anfragen und 1250 Nachrichten pro Tag.
 *
 * Höchstwerte wie DAILY_LIMIT_MAXIMUMS im Backend (linkedin-accounts.schemas.ts).
 * Profilbesuche: Standard 250 (22.10.2026, vorher 150).
 */
export const DAILY_LIMIT_RECOMMENDED = {
  connections: 25,
  messages: 100,
  inmails: 20,
  visits: 250,
  emails: 30,
} as const;

export const DAILY_LIMIT_MAXIMUMS = {
  connections: 100,
  messages: 200,
  inmails: 25,
  visits: 500,
} as const;
